
document.addEventListener('show.bs.collapse', function(event) {
	var collapseEl = event.target;
	if (!collapseEl.classList.contains('gsp-filter-more-collapse')) return;

	var id = collapseEl.id;
	if (!id) return;

	var toggle = document.querySelector('.gsp-filter-toggle-more[data-bs-target="#' + id + '"]');
	if (!toggle) return;

	toggle.textContent = toggle.getAttribute('data-label-less') || 'Show less';
});

document.addEventListener('hide.bs.collapse', function(event) {
	var collapseEl = event.target;
	if (!collapseEl.classList.contains('gsp-filter-more-collapse')) return;

	var id = collapseEl.id;
	if (!id) return;

	var toggle = document.querySelector('.gsp-filter-toggle-more[data-bs-target="#' + id + '"]');
	if (!toggle) return;

	toggle.textContent = toggle.getAttribute('data-label-more') || 'Show more';
});

document.addEventListener('change', function(event) {
	var input = event.target.closest('.gsp-filter-more-collapse input');
	if (!input) return;

	var filterRoot = input.closest('gsp-widget-filter-list, gsp-filter-list');
	if (!filterRoot) return;

	var primaryWrapper = filterRoot.querySelector('.gsp-product-option-content');
	if (!primaryWrapper) return;

	primaryWrapper.dispatchEvent(new Event('change', { bubbles: true }));
});

function handleFilterSearch(event) {
	var input = event.target;
	if (!input.hasAttribute('data-filter-search')) return;

	var query = input.value.toLowerCase().trim();
	var collapseId = input.getAttribute('data-filter-search-collapse');
	var filterRoot = input.closest('gsp-widget-filter-list, gsp-filter-list');
	if (!filterRoot) return;

	var items = filterRoot.querySelectorAll('[data-filter-search-item]');
	var hasMatchInCollapse = false;

	items.forEach(function(item) {
		var label = item.getAttribute('data-filter-search-label') || '';
		var matches = query === '' || label.indexOf(query) !== -1;

		item.style.display = matches ? '' : 'none';

		if (matches && collapseId && item.closest('#' + collapseId)) {
			hasMatchInCollapse = true;
		}
	});

	if (collapseId) {
		var collapseEl = document.getElementById(collapseId);
		if (!collapseEl) return;

		var bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl, { toggle: false });

		if (query !== '' && hasMatchInCollapse && !collapseEl.classList.contains('show')) {
			bsCollapse.show();
		} else if (query === '' && collapseEl.classList.contains('show')) {
			bsCollapse.hide();
		}
	}
}

document.addEventListener('input', handleFilterSearch);
document.addEventListener('change', function(event) {
	// Обрабатываем type="search" нативную ✕ — только если не checkbox/radio
	var el = event.target;
	if (el.type === 'search' && el.hasAttribute('data-filter-search')) {
		handleFilterSearch(event);
	}
});